module.exports = __webpack_public_path__ + "static/13-93da31ebce8dedc5ed4c6cf9ae517ab1.jpg";